module.exports = __webpack_public_path__ + "img/planForBirth.ac6785bb.png";